import type { IconSvgObject } from './types';

const ChevronRightIcon: IconSvgObject = [
  ["path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ChevronRightIcon;
